import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = _props => {
  const { t } = useTranslation('listStocks')
  return (
    <Title size="h4" align="center" noMargin>
      {t('transfersHistory.title')}
    </Title>
  )
}

export default ModalHeader
